import React from 'react';
import { ReactComponent as RestartIcon } from '../../assets/img/icons/assistant/Restart.svg';

const AIAssistantInitializing = ({ children }) => {
  const content = children || 'AI Assistant initializing. Please wait...';
  
  return (
    <div className="ai-assistant-status">
      <div className="ai-assistant-status-initializing">
        <RestartIcon />
      </div>
      
      <div className="ai-assistant-status-text">{content}</div>
    </div>
  );
};

export default AIAssistantInitializing;
